<template>
  <article class="multicity" >
    <header class="multicity__header">
      <component
        :is="flightTypeComponent"
        v-model="flightType"
        :options="[
          { name: 'one_way', label: 'multicity_oneway', show: bookingData.oneWay },
          { name: 'round_trip', label: 'multicity_roundtrip', show: bookingData.roundTrip },
          { name: 'multicity', label: 'multicity_journey', show: true }
        ]"
      />
      <div class="multicity__headerDivisor">
        <Passengers
          v-if="!isBookingWidget"
          :cabins="bookingData.cabin"
          :passengers="bookingData.passengers"
          v-model="passengers"
          :key="`passengers`"
        />
        <country-settings
          :country-settings="bookingData.countrySettings"
          v-model="countrySetting"
          :fixed-pos="0"
        />
      </div>
    </header>
    <draggable 
      v-model="flights"
      group="FlightSelector"
      handle=".handle"
      @change="onFlightMoved"
      class="multicity__FlightsContainer"
    >
      <MulticityFlightSelector
        v-for="(_flight, index) in flights"
        :key="`flight_${index}`"
        :ref="`flight_${index}`"
        :booking-data="bookingData"
        :display-target="displayTarget"
        :flight="_flight"
        @onFlightSelected="selectedFlight => onFlightSelected(selectedFlight, index)"
        @onDelete="deleteFlight(index)"
        :show-delete="(index === flights.length - 1) && flights.length > 2"
        :id="index + 1"
      />
    </draggable>
    <div class="buttons-container">
      <button
        class="multicity__actionButton btn btn-primary"
        @click="addLegFlight"
      >
        <i class="fas fa-add"></i>
        <span>{{ $t('multicity_add_button') }}</span>
      </button>
      <button v-if="!isBookingWidget"
        class="multicity__actionButton btn btn-primary"
      >
        <i class="fas fa-search"></i>
        <span>{{ $t('multicity_search_button') }}</span>
      </button>
    </div>
    <Passengers
      v-if="isBookingWidget"
      :cabins="bookingData.cabin"
      :passengers="bookingData.passengers"
      v-model="passengers"
      :key="`passengers`"
    >
    </Passengers>
  </article>
</template>

<script>
import Passengers from 'core-lib/components/searcher/Passengers.vue'
import MulticityFlightSelector from '../multicity/MulticityFlightSelector.vue'
import draggable from 'vuedraggable'
import FlightType from 'core-lib/components/searcher/FlightType.vue'
import FlightTypeRadio from 'core-lib/components/searcher/FlightTypeRadio.vue'
import CountrySettings from 'core-lib/components/searcher/CountrySettings.vue'
export default {
  name: "Multicity",
  components: {
    MulticityFlightSelector,
    Passengers,
    draggable,
    'FlightTypeSelect': FlightType,
    FlightTypeRadio,
    CountrySettings
  },
  props: {
    bookingData: null,
    displayTarget: null,
    isBookingWidget: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      flights: [{}, {}],
      passengers: null,
      flightType: 'multicity',
      countrySetting: null
    }
  },
  watch: {
    flightType: function (newValue) {
      if (!newValue.isMulticity) {
        this.$store.commit('setRoundtripFromMulticity', newValue.isRoundtrip)
        this.$router.push(`/booking`)
      }
    }
  },
  methods: {
    onFlightMoved: function () {
      const refs = this.$refs
      this.flights.forEach((_, index) => {
        const flightRef = refs[`flight_${index}`]
        const datePickerRef = flightRef[0].$refs['multicity_datepicker']
        datePickerRef.departure = null
        datePickerRef.resetStartDate()
      })
      this.$forceUpdate()
    },
    onFlightSelected: function (selectedFlight, actualIndex) {
      this.flights[actualIndex] = selectedFlight
    },
    addLegFlight: function () {
      this.flights.push({})
    },
    deleteFlight: function (index) {
      this.flights.splice(index, 1)
    }
  },
  computed: {
    flightTypeComponent: function () {
      this.widgetSetup = this.$store.getters.getGeneralSettings.ecommerce_setup.widget_setup
      return (this.widgetSetup.journey_component.toLowerCase()).replace('1- ', '')
    }
  }
}

</script>
<style lang="sass" scoped>
.multicity
  padding: 1rem
  width: 100%
  display: flex
  flex-direction: column
  gap: 1.5rem
  &__actionButton
    display: flex
    align-items: center
    gap: .5rem
    span
      font-weight: bold
  &__header
    display: flex
    justify-content: space-between
    align-items: center
    &Divisor
      display: flex
      align-items: center
      gap: 1.5rem
  &__FlightsContainer
    display: grid
    gap: 1.25rem
.buttons-container
  display: flex
  justify-content: space-between
</style>
<style lang="sass">
.multicity
  .datepickerInput,
  .inputText,
  .inputSelect
    margin-bottom: 0 !important
  .surface
    padding: 1rem !important
  .autocompleteAirport
    margin: 0 !important
  .multicity__headerDivisor .passengersComponent
    max-width: 5rem
  .passengersComponent
    input
      border: none
</style>